import { BaseDto } from './base.dto';

export class GenderDto extends BaseDto {
  id: number;
  gender: string;
}
